import React, { useEffect, useState } from "react";
import styles from "./ProductViews.module.sass";
import Card from "../../../components/Card";
import useDarkMode from "use-dark-mode";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const calculateHeight = (data) => {
  return data.length * 45;
};

const ProductViews = ({ assignmentData, isAssignmentsLoading }) => {
  const darkMode = useDarkMode(false);
  return (
    <Card
      className={styles.card}
      title="Assigned Orders"
      classTitle="title-blue"
    >
      <div className={styles.chart}>
        {isAssignmentsLoading ? (
          <div>Loading...</div>
        ) : assignmentData && assignmentData.length > 0 ? (
          <ResponsiveContainer
            width="100%"
            height={calculateHeight(assignmentData)}
          >
            <BarChart
              width={500}
              height={300}
              data={assignmentData}
              layout="vertical"
              margin={{
                top: 0,
                right: 0,
                left: 5,
                bottom: 0,
              }}
              barSize={24}
              barGap={8}
            >
              <CartesianGrid
                strokeDasharray="none"
                stroke={darkMode.value ? "#272B30" : "#EFEFEF"}
                horizontal={false}
              />
              <XAxis
                type="number"
                axisLine={false}
                tickLine={false}
                tick={{
                  fontSize: 12,
                  fontWeight: "500",
                  fill: "#6F767E",
                }}
                padding={{ left: 10 }}
              />
              <YAxis
                type="category"
                dataKey="name"
                axisLine={false}
                tickLine={false}
                interval={0}
                tick={{
                  fontSize: 12,
                  fontWeight: "500",
                  fill: "#6F767E",
                  padding: 10,
                }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#272B30",
                  borderColor: "rgba(255, 255, 255, 0.12)",
                  borderRadius: 8,
                  boxShadow:
                    "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
                }}
                labelStyle={{
                  fontSize: 12,
                  fontWeight: "500",
                  color: "#fff",
                }}
                itemStyle={{
                  padding: 0,
                  textTransform: "capitalize",
                  fontSize: 12,
                  fontWeight: "600",
                  color: "#fff",
                }}
                cursor={{ fill: "#f3f2f3" }}
              />
              <Bar dataKey="orders" fill="#B5E4CA" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div>No data available</div>
        )}
      </div>
    </Card>
  );
};

export default ProductViews;
